export const KIND_LABEL = { weekly_local: 'Weekly – Local Lab', monthly_thyrocare: 'Monthly – Thyrocare' };

const STATUS = {
  pending: 'bg-amber-100 text-amber-800 border-amber-300',
  approved: 'bg-sky-100 text-sky-800 border-sky-300',
  rejected: 'bg-red-100 text-red-700 border-red-300',
  paid: 'bg-emerald-100 text-emerald-800 border-emerald-300',
};

export const StatusBadge = ({ status, testId }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold uppercase border ${STATUS[status]}`} data-testid={testId}>{status}</span>
);

const d = (s) => new Date(`${s}T00:00:00`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
export const periodText = (s) => `${d(s.start)} – ${d(s.end)}`;
export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true }) : '');

export const SettlementMeta = ({ s }) => (
  <div className="text-xs text-slate-500 space-y-0.5">
    {s.note && <p className="text-slate-700">“{s.note}”</p>}
    <p>Raised by {s.raised_by} • {when(s.raised_at)}</p>
    {s.decided_at && <p>{s.status === 'rejected' ? 'Rejected' : 'Approved'} by {s.decided_by} • {when(s.decided_at)}{s.reject_reason && ` — ${s.reject_reason}`}</p>}
    {s.paid_at && <p className="text-emerald-700 font-semibold">Paid via {s.paid_mode.toUpperCase()}{s.paid_ref && ` (Ref: ${s.paid_ref})`} • {when(s.paid_at)}</p>}
  </div>
);
